import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import "./SkillsModal.css";

function SkillsModal({ show, handleClose }) {
  const skillOptions = [
    { value: "Html5", label: "Html5" },
    { value: "Css3", label: "Css3" },
    { value: "React", label: "React" },
    { value: "Javascript", label: "Javascript" },
    { value: "Bootstrap", label: "Bootstrap" },
    { value: "Frontend Development", label: "Frontend Development" },
    { value: "Responsive Design & Optimization", label: "Responsive Design & Optimization" },
    { value: "Mobile-first design", label: "Mobile-first design" },
    { value: "cross-browser compatibility", label: "cross-browser compatibility" },
    { value: "Software Development", label: "Software Development" },
    { value: "Redux", label: "Redux" },
    { value: "Git", label: "Git" },
    { value: "REST API", label: "REST API" },
    { value: "Material UI", label: "Material UI" },
    { value: "Tailwind CSS", label: "Tailwind CSS" },
  ];

  const [skills, setSkills] = useState([
    { value: "Html5", label: "Html5" },
    { value: "Css3", label: "Css3" },
    { value: "React", label: "React" },
    { value: "Javascript", label: "Javascript" },
    { value: "Bootstrap", label: "Bootstrap" },
    { value: "Frontend Development", label: "Frontend Development" },
    { value: "Responsive Design & Optimization", label: "Responsive Design & Optimization" },
    { value: "Mobile-first design", label: "Mobile-first design" },
    { value: "cross-browser compatibility", label: "cross-browser compatibility" },
    { value: "Software Development", label: "Software Development" },
  ]);

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: 140,
      border: "1px solid #d9dee8",
      borderRadius: 4,
      boxShadow: "none",
      alignItems: "flex-start",
      padding: "10px",
    }),

    valueContainer: (base) => ({
      ...base,
      display: "flex",
      flexWrap: "wrap",
      gap: "10px",
      padding: 0,
    }),

    multiValue: (base) => ({
      ...base,
      background: "#fff",
      border: "1px solid #585858",
      borderRadius: 20,
      padding: "3px 8px",
    }),

    multiValueLabel: (base) => ({
      ...base,
      color: "#202124",
      fontSize: 14,
    }),

    multiValueRemove: (base) => ({
      ...base,
      cursor: "pointer",
      borderRadius: "50%",
      ":hover": {
        background: "transparent",
        color: "#000",
      },
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    dropdownIndicator: () => ({
      display: "none",
    }),

    placeholder: (base) => ({
      ...base,
      color: "#9ca3af",
    }),
  };

  const handleSave = () => {
    console.log(skills);
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      dialogClassName="common-modal skills-modal"
    >
      <Modal.Header className="skills-modal__header">
        <Modal.Title>
          <Button
            variant="link"
            className="we-back-btn p-0 me-2"
            onClick={handleClose}
          >
            <FontAwesomeIcon icon={faAngleLeft} />
          </Button>
          Edit Skills
        </Modal.Title>

        <button
          className="btn-close"
          onClick={handleClose}
        ></button>
      </Modal.Header>

      <Modal.Body className="skills-modal__body">
        <Form.Group>
          <Select
            isMulti
            options={skillOptions}
            value={skills}
            onChange={setSkills}
            styles={customStyles}
            placeholder="Maximum 50 can be added"
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer className="skills-modal__footer">
        <Button
          className="skills-modal__save"
          disabled={!skills.length}
          onClick={handleSave}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SkillsModal;